import { useNavigate, useLocation } from 'react-router'
import type { LucideIcon } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'

type TabItem = {
  label: string
  path: string
  icon?: LucideIcon
}

type TabProps = {
  tabs: TabItem[]
}

export function Tab({ tabs }: TabProps) {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className="mb-8 flex items-center gap-3 border-b-[0.5px] border-b-[var(--rule)]">
      {tabs.map((tab) => {
        const isActive = location.pathname.startsWith(tab.path)
        const Icon = tab.icon
        return (
          <Button
            type="button"
            variant="ghost"
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={cn(
              'mb-[-0.5px] flex items-center gap-1.5 rounded-none [border-bottom-style:solid] border-b-[1.5px] border-b-transparent bg-transparent pb-3 text-sm font-normal uppercase tracking-[0.1em] transition-all duration-150 hover:bg-transparent',
              isActive
                ? 'text-[var(--ink)] border-b-[var(--green)] hover:text-[var(--ink)]'
                : 'text-[var(--ink-3)] hover:text-[var(--ink)]'
            )}
          >
            {Icon ? <Icon className="h-3 w-3" /> : null}
            {tab.label}
          </Button>
        )
      })}
    </div>
  )
}
